import { Claim } from '../models/Claim';
import { ClientCredential } from '../models/ClientCredential';
import { userApiProvider } from './providers/userApiProvider';
var clientCredential = {
    create: function create(input) {
        return userApiProvider.post("/clientcredentials", input, ClientCredential);
    },
    getAll: function getAll() {
        return userApiProvider.get("/clientcredentials/all", ClientCredential);
    },
    remove: function remove(input) {
        return userApiProvider.del("/clientcredentials/".concat(input.id));
    },
    update: function update(input) {
        return userApiProvider.put("/clientcredentials/".concat(input.id), input, ClientCredential);
    }
};
var claims = {
    create: function create(input) {
        return userApiProvider.post("/clientcredentials/scopes", input, Claim);
    },
    getAll: function getAll() {
        return userApiProvider.get("/clientcredentials/scopes/all", Claim);
    },
    remove: function remove(input) {
        return userApiProvider.del("/clientcredentials/scopes/".concat(input.id));
    },
    update: function update(input) {
        return userApiProvider.put("/clientcredentials/scopes", input, Claim);
    }
};
var clientCredentialApi = {
    clientCredential: clientCredential,
    claims: claims
};
export default clientCredentialApi;
